var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"efactura-receiver"},[_c('span',{staticClass:"efactura-receiver-name"},[_vm._v(_vm._s(_vm.data.company_name || '—'))]),_c('span',{staticClass:"efactura-receiver-cui"},[_vm._v(_vm._s(_vm.cui))])])}
var staticRenderFns = []

export { render, staticRenderFns }